import CompraDFeManifestoUltimaConsultaService from "@/services/CompraDFeManifestoUltimaConsultaService";

export const compraDFeManifestoUltimaConsulta = {
  namespaced: true,
  state: {
    compraDFeManifestoUltimaConsulta: {},
  },
  actions: {
    getCompraDFeManifestoUltimaConsulta({ commit }, payload) {
      return CompraDFeManifestoUltimaConsultaService.GetCompraDFeManifestoUltimaConsulta(
        payload
      ).then(
        (compraDFeManifestoUltimaConsulta) => {
          return Promise.resolve(compraDFeManifestoUltimaConsulta);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postCompraDFeManifestoUltimaConsulta({ commit }, payload) {
      return CompraDFeManifestoUltimaConsultaService.PostCompraDFeManifestoUltimaConsulta(
        payload
      ).then(
        (compraDFeManifestoUltimaConsulta) => {
          return Promise.resolve(compraDFeManifestoUltimaConsulta);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putCompraDFeManifestoUltimaConsulta({ commit }, payload) {
      return CompraDFeManifestoUltimaConsultaService.PutCompraDFeManifestoUltimaConsulta(
        payload
      ).then(
        (compraDFeManifestoUltimaConsulta) => {
          return Promise.resolve(compraDFeManifestoUltimaConsulta);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteCompraDFeManifestoUltimaConsulta({ commit }, payload) {
      return CompraDFeManifestoUltimaConsultaService.DeleteCompraDFeManifestoUltimaConsulta(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getCompraDFeManifestoUltimaConsultaOData({ commit }, payload) {
      return CompraDFeManifestoUltimaConsultaService.GetCompraDFeManifestoUltimaConsultaOData(
        payload
      ).then(
        (compraDFeManifestoUltimaConsulta) => {
          return Promise.resolve(compraDFeManifestoUltimaConsulta);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default compraDFeManifestoUltimaConsulta;
